import React, { Component } from 'react';
import { ActionCreators } from '../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';

import '../../styles/job-list.css';

class Applicants extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keyword: "",
            applicants: []
        }
    }

    componentWillMount(){
        this.props.getApplicantAction().then(() => {
            if(this.props.applicants){
                this.search();
            }
        });
    }

    search(){
        if(this.props.applicants){
            let applicants = this.props.applicants.data;

            if(this.state.keyword !== ""){
                applicants =    applicants.filter(x =>
                                    x.firstName.toLowerCase().includes(this.state.keyword.toLowerCase()) ||
                                    x.lastName.toLowerCase().includes(this.state.keyword.toLowerCase()) ||
                                    x.email.toLowerCase().includes(this.state.keyword.toLowerCase()) ||
                                    x.skills.toLowerCase().includes(this.state.keyword.toLowerCase()) ||
                                    x.vacancy.jobTitle.toLowerCase().includes(this.state.keyword.toLowerCase())
                                );
            }

            this.setState(prevState => ({
                ...prevState,
                applicants: applicants
            }))
        }
    }

    render() {
        return (
            <div className="job-list">

                <div className="job-search-box">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-9 queryBox">
                                <input
                                    type="text"
                                    placeholder="Search applicant by name, job, email or skill"
                                    onChange = { (event) => {
                                        this.setState({
                                            keyword: event.target.value
                                        });
                                    }}
                                    />
                            </div>
                            <div className="col-xl-3 searchButton">
                                <button className="gs-btn gs-btn-pink" onClick={() => { this.search() }}>Search</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="jobs">
                    <div className="container">
                        <div className="row">
                            {
                                this.state.applicants &&
                                this.state.applicants.map((a, i) => {
                                    return  <div className="col-xl-4" key={a.id}>
                                                <div className="job">
                                                    <div className="job-body">
                                                        <div className="job-title">{ a.firstName+" "+a.lastName }</div>
                                                        <div className="job-metas">
                                                            <div className="meta">
                                                                <i className="icon-briefcase"></i>
                                                                { a.vacancy && a.vacancy.jobTitle }
                                                            </div>
                                                            <div className="meta">
                                                                <i className="icon-envelope"></i>
                                                                { a.email && a.email }
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col">
                                                                {
                                                                    a.skills &&
                                                                    a.skills.split(",").map((s,i) => {
                                                                        return <span key={i} className="skill-chip">{ s }</span>
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col">
                                                                <Link to={{ pathname: "/aoc/applicant/"+a.id+"/detail", applicant: a }} className="gs-btn gs-btn-blue mt-3">See detail</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                })
                            }

                            {
                                this.state.applicants && this.state.applicants.length === 0 &&
                                <div className="col text-center">No vacancy match the criteria.</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        applicants: state.applicants
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Applicants));


// WEBPACK FOOTER //
// ./src/pages/auth/applicant.js